<template>
  <LabelBase :value="label" :for="id" />
  <component
    :is="getComponent"
    class="mt-1"
    :id="id"
    v-model="localValue"
    :type="props.type"
    :error="props.error"
    v-bind="$attrs"
  />
  <InputError :message="props.error" />
</template>

<script setup>
import { computed } from 'vue'

import InputError from './InputError.vue'
import LabelBase from '../LabelBase.vue'
import InputBase from './InputBase.vue'
import InputDate from './InputDate.vue'
import InputDateTimeLocal from './InputDateTimeLocal.vue'

const emits = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: [String, Number],
  error: String,
  label: String,
  type: {
    default: 'text',
  },
})

const id = computed(() => 'input_' + _.uniqueId())

const localValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits('update:modelValue', value)
  },
})

const getComponent = computed(() => {
  let known = {
    date: InputDate,
    text: InputBase,
    'datetime-local': InputDateTimeLocal,
  }[props.type]

  if (known) return known
  return InputBase
})
</script>
